import { message } from 'antd';
import PropTypes from 'prop-types';
import './style.css';

const Message = ({ className, type, content, duration }) => {
  message.open({
    className,
    type,
    content,
    duration,
  });
};

Message.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  content: PropTypes.string,
  duration: PropTypes.number,
};

export { Message };
